/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./tapUp.vue?vue&type=template&id=5411f308&scoped=true"
import script from "./tapUp.vue?vue&type=script&lang=js"
export * from "./tapUp.vue?vue&type=script&lang=js"
import style0 from "./tapUp.vue?vue&type=style&index=0&id=5411f308&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5411f308",
  null
  
)

export default component.exports